import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  GetDecizieNivelRiscResponse,
  SaveDecizieNivelRiscResponse,
} from "@/api/types/notificari";
import type { DecizieNivelRiscInput } from "@/types/notificariRecalcul";

export async function getDecizieNivelRisc(
  sessionId: string
): Promise<GetDecizieNivelRiscResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/decizie-nivel-risc/${sessionId}`,
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  if (!data) throw new Error("Răspuns invalid de la decizie-nivel-risc");
  return data;
}

export async function saveDecizieNivelRisc(
  input: DecizieNivelRiscInput
): Promise<SaveDecizieNivelRiscResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/decizie-nivel-risc",
    { method: "POST", body: input }
  );
  await handleSupabaseFunctionError(error);
  if (!data)
    throw new Error("Răspuns invalid la salvarea deciziei de nivel de risc");
  return data;
}
